module.exports = __webpack_public_path__ + "assets/people/andrewButko.bd2546b2bf7af2e883814395bf6914bc.png";